import "./professionalBio.css";

const TiffanyCookKingBioContent = (
  <div className="info-box-style">
    <p>
      You deserve a therapeutic space where you don't have to translate,
      minimize, or mask who you are to be understood. My role isn't to tell you
      who you should become, it's to walk alongside you as you deepen your
      understanding of yourself, reconnect with your inner wisdom, and build a
      life that feels more authentic and sustainable.
      <br />
      <br />
      I work with neurodivergent and LGBTQIA+ adults who want a therapist who
      recognizes, affirms, and respects the fullness of their identities. I'm
      especially passionate about supporting adults who were diagnosed with
      autism or ADHD later in life, are exploring neurodivergence, or are
      beginning to understand how years of masking have impacted their identity,
      relationships, and emotional well-being. I also have a growing focus on
      the intersection of autism and hormonal transitions, including PMDD and
      menopause, and how these changes can intensify sensory, emotional, and
      cognitive experiences. In addition, I support neurodivergent couples
      navigating the ebbs and flows of their relationship.
      <br />
      <br />
      As a Black, queer therapist who is autistic and has ADHD, I understand
      what it feels like to navigate systems and spaces that weren't designed
      with your mind, body, identities, or needs in mind. I also know the
      exhaustion of constantly adapting yourself to meet other people's
      expectations. My lived experience shapes how I show up in the therapy
      room, but I stay curious about your individual story. Shared identities
      can create real connection, but they don't make our experiences identical.
      <br />
      <br />
      I strive to create a space that's warm, affirming, honest, and flexible,
      one where you can stim, pause, ask questions, use humor, communicate
      differently, or take your time finding the words. You don't have to mask,
      perform wellness, or arrive with everything figured out. You are welcome
      to come exactly as you are.
    </p>
  </div>
);

export default TiffanyCookKingBioContent;